import { CountryCodes } from "../../constants/CountryCodes"
import LocationService from "../../services/LocationService"
import SubFacilityService from "../Organizations/MedicalCareFacility/SubFacility/SubFacilityService"

const CityState = ({ formFn, data, organizationId }) => {

  formFn.health_center_path = 'phc_name';

  formFn.get_health_center = (search, onSuccess, onFailure) => {
    let req = {
      'page': 1,
      'per_page': 100,
      'search': search,
      'sort_column': 'name'
      /*district: data.district,
      taluka: data.taluka*/
    }

    LocationService.getPublicHealthCenters(req).then((res) => {
      onSuccess(res.data.health_centers);
    })
  }

  formFn.set_health_center = (item) => {
    data.health_center = item.phc_name;
    data.health_center_fk_id = item.record_id;
  }

  formFn.country_path = 'name';

  formFn.get_country = (search, onSuccess, onFailure) => {
    let req = {
      'page': 1,
      'per_page': 100,
      'search': search,
      'sort_column': 'name',
      'sort_direction': 'asc'
    }
    LocationService.get_countries(req).then((res) => {
      onSuccess(res.data.countries);
    })
  }

  formFn.set_country = (item) => {
    data.country = item.name;
    data.country_code = item.iso2;
    setPhoneFormat();
  }

  const setPhoneFormat = () => {
    const f = data.country_code ? CountryCodes[data.country_code.toLowerCase()] : null;
    formFn.phone_display_format = f?.[4];
    formFn.country_code = f?.[2];
  }

  formFn.state_path = 'name';

  formFn.get_state = (search, onSuccess, onFailure) => {
    let req = {
      'page': 1,
      'per_page': 100,
      'search': search,
      'country_code': data.country_code,
      'sort_column': 'name',
      'sort_direction': 'asc'
    }
    LocationService.get_state(req).then((res) => {
      onSuccess(res.data.states);
    })
  }

  formFn.set_state = (item) => {
    data.state = item.name;
    data.state_id = item.id;
  }

  formFn.city_path = 'name'
  formFn.get_city = (search, onSuccess, onFailure) => {
    LocationService.get_city({
      'page': 1,
      'per_page': 100,
      'country_code': data.country_code,
      'state_id': data.state_id,
      'search': search,
      'sort_column': 'name',
      'sort_direction': 'asc'
    }).then((res) => {
      onSuccess(res.data.cities);
    })
  }

  formFn.set_city = (item) => {
    data.city = item.name;
    data.city_id = item.id;
  }

  formFn.taluka_path = 'sub_district_name'
  formFn.get_taluka = (search, onSuccess, onFailure) => {
    LocationService.get_taluka({
      'country_name': data.country,
      'state_name': data.state,
      'district_code': data.district_code,
      'search': search
    }).then((res) => {
      onSuccess(res.data.sub_districts);
    })
  }

  formFn.set_taluka = (item) => {
    data.taluka = item.sub_district_name;
    data.taluka_code = item.sub_district_code;
  }

  formFn.village_path = 'block_village_name'
  formFn.get_village = (search, onSuccess, onFailure) => {
    LocationService.get_village({
      'country_name': data.country,
      'state_name': data.state,
      'district_name': data.district,
      'search': search
    }).then((res) => {
      onSuccess(res.data.villages);
    })
  }

  formFn.set_village = (item) => {
    data.village = item.village_name;
    data.village_code = item.village_code;
    if (item.block_code) {
      data.block = item.block_name;
      data.block_code = item.block_code;
    }
    if (item.sub_district_name) {
      data.taluka = item.sub_district_name;
      data.taluka_code = item.sub_district_code;
    }
  }

  formFn.sub_facility_path = 'name';

  formFn.get_sub_facility = (search, onSuccess, onFailure) => {
    const req = {
      'page': 1,
      'per_page': 100,
      'organization_id': organizationId,
      'search': search,
      'default_fields': 'ignore',
      'fields': ["record_id", "data.name"],
      'filter': {
        'district': data.district,
        'taluka': data.taluka,
        'village': data.village
      }
    }

    SubFacilityService.getAll(req).then((res) => {
      onSuccess(res.data.sub_facilities);
    })
  }

  formFn.set_sub_facility = (item) => {
    data.sub_facility = item.name;
    data.sub_facility_fk_id = item.record_id;
  }

  //awc 
  formFn.awc_name_number_path = "name";
  formFn.get_awc_name_number = (search, on_success, on_failure) => {
    return formFn.get_sub_facility(search, on_success, on_failure);
  }

  formFn.set_awc_name_number = (item) => {
    data.awc_name_number = item.name;
    data.awc_name_number_fk_id = item.record_id;
  }

  return null;
}

export { CityState }